import { DATABASE_UPDATE } from "../actions/database";
import buildReducer from "./build-reducer";
import { fromJS, Map } from "immutable";

let reducers = {};

reducers[DATABASE_UPDATE] = (state, { tables: { bets } }) => {
  if (bets === undefined) {
    return state;
  }
  var betMap = bets.reduce((byRace, bet) => {
    if (byRace.has(bet.race_id)) {
      return byRace.setIn([bet.race_id, bet.id], fromJS(bet));
    }
    return byRace.set(bet.race_id, Map().set(bet.id, fromJS(bet)));
  }, Map());
  return state.mergeDeep(betMap);
};

export default buildReducer(Map(), reducers);
